export default "__VITE_ASSET__Ck_ZdQk7__"